import { createContext } from "react";
import type { NameLocalizations } from '../api/localization';

export interface UserProfileContextValue {
  empName: string;
  empDisplayName?: string;
  empNameLocalizations?: NameLocalizations;
  userBranch: string;
  showSuper: boolean;
  showLanguage: boolean;
  pendingDanger: number | null;
  pendingAnnouncements: number;
  canApproveFinance: boolean;
  isManager: boolean;
  isGeneralManager: boolean;
  isMarketingMoney: boolean;
  /** True after the profile request has conclusively resolved (success or failure). */
  profileResolved?: boolean;
}

export const UserProfileContext = createContext<UserProfileContextValue | null>(
  null
);
